/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AllResultsStationSimResult } from './AllResultsStationSimResult';
import {
    AllResultsStationSimResultFromJSON,
    AllResultsStationSimResultFromJSONTyped,
    AllResultsStationSimResultToJSON,
    AllResultsStationSimResultToJSONTyped,
} from './AllResultsStationSimResult';

/**
 * すべての観測所の予測処理結果
 * @export
 * @interface AllResultsResponse
 */
export interface AllResultsResponse {
    /**
     * 観測所リスト
     * @type {Array<AllResultsStationSimResult>}
     * @memberof AllResultsResponse
     */
    stations: Array<AllResultsStationSimResult>;
}

/**
 * Check if a given object implements the AllResultsResponse interface.
 */
export function instanceOfAllResultsResponse(value: object): value is AllResultsResponse {
    if (!('stations' in value) || value['stations'] === undefined) return false;
    return true;
}

export function AllResultsResponseFromJSON(json: any): AllResultsResponse {
    return AllResultsResponseFromJSONTyped(json, false);
}

export function AllResultsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllResultsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'stations': ((json['stations'] as Array<any>).map(AllResultsStationSimResultFromJSON)),
    };
}

export function AllResultsResponseToJSON(json: any): AllResultsResponse {
    return AllResultsResponseToJSONTyped(json, false);
}

export function AllResultsResponseToJSONTyped(value?: AllResultsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stations': ((value['stations'] as Array<any>).map(AllResultsStationSimResultToJSON)),
    };
}

